
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexe28H9qZKJG0ee_udOwpYs4uVwI6Ib00_45hj_EU8_45hcjEMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/index.vue?macro=true";
import { default as ar_45_91id_93LhlK_45R3cSVaIKML1PQT8_ord9SFw3lUXOc6DQ0SHWa4Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/ar-[id].vue?macro=true";
import { default as app_45_91id_93_I6d4Uo5eQxAQVnFJsIs3M9aIlQHVt7T8nH4Z9jE7KEMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/app-[id].vue?macro=true";
import { default as indexn_wXXAkqzMBi9C_452x97ytc9fvheGCQLV1LB4Y022bMwMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/faqs/index.vue?macro=true";
import { default as make_45errorz3Ag9kCcfFiL9I3X0bCnDvSdJNALdYqVnDbF6UPYnz0Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/make-error.vue?macro=true";
import { default as indexuTU3rmCUxyHRdCUPOfouJK1Eh5i27pmT067U9wVD7oAMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/funds/index.vue?macro=true";
import { default as summarygvQc9vE_kfwKV3c6_ncEgyXaqdpqWCSn6y8Xr0W0_KMMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/pdf/summary.vue?macro=true";
import { default as createzF65Y_5SBhcuOKnnPdqcpnRY8vB6OqGmDKBr_45I7xM8QMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/funds/create.vue?macro=true";
import { default as generate_45errord2RDOA7KsuVCNGFMD6AqEMug4RCbW61QhM8aNnzSeJ8Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/generate-error.vue?macro=true";
import { default as indexh6fep9jDnqSH_45z8fVgyuC0SOzSXuGaTi3HEUrPTUeskMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/schedule/index.vue?macro=true";
import { default as indexHxaq_Txfx6QJ50zeP15HHPZduDXve1EKHs2M9uIIYRQMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/oversight/index.vue?macro=true";
import { default as custom_45formajpYSJHHuSxDSwibBzgwBkDNacGX3xNGBFPTQtPi3skMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/pdf/custom-form.vue?macro=true";
import { default as fpl_45summaryaoElr_45wA_EORZF7Z0wnYDDrVwBywRnVI_QJUVyjt3aEMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/pdf/fpl-summary.vue?macro=true";
import { default as indexy0uUHBZR2pCJ8BEk57100o0uyiZOqL7dkLldMLk0_GIMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/applicants/index.vue?macro=true";
import { default as indexesiTUuwKnUQp2PiQaBOXabv_45HytBAXSFxmNAwG7QoSwMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/funds/[id]/index.vue?macro=true";
import { default as print_454crxpbWzO56lzbX9GVrZGuHLzxCSv8t8n0DusUGGvQMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/funds/[id]/print.vue?macro=true";
import { default as with_45countyqtrp9t4yuNarNG2u_45hdjQ7DJA2RmuYngwM6ImlQ8QNsMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/maps/with-county.vue?macro=true";
import { default as with_45markerybAggDGYH0uZRZxVFg1hPdN9zenDGhpei9ohr_45SXyJEMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/maps/with-marker.vue?macro=true";
import { default as index_JuOd4io5GeeAx_4584bNVd4G_45cbcEBV2B9EaPIH8ZyRsMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/access-code/index.vue?macro=true";
import { default as _91id_93SGsu7anR622Fh5NzmmIMwuLyliOeabW67iP4JemMR0kMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/appointments/[id].vue?macro=true";
import { default as preview0CUBkymUGLIXfZVSyLSf1_45cFUdTk6ygNtGi2tTZdOUgMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/documents/preview.vue?macro=true";
import { default as audit_45summaryG_36qMk3K7NYDrQVHJ13KzXJNdSGi52944562PlCax0Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/pdf/audit-summary.vue?macro=true";
import { default as indexPFWnZeQhGoKVq_mBUt0i5XYr0YxXiSwbaMV1wV6gD2kMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/index.vue?macro=true";
import { default as index7Ezj_45zVNLBuBmBdIxoUwgCy6ObvrcPLi0JWOaC5pQL0Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/appointments/index.vue?macro=true";
import { default as _91id_93v7lVgWc7USDajdiN_bJV7AoZlDMwPiQPEoT_45qSJ3VAAMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/service-areas/[id].vue?macro=true";
import { default as manageh7XrFxzTEJ3y9b8_Q_45TBotX4W0Jc56O0Z6FmkhmwTJIMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/appointments/manage.vue?macro=true";
import { default as indexs_45mQUDtTRaPzHgZR_451NnLrP6EgBMBwOLlwpbCQFMBO8Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/service-areas/index.vue?macro=true";
import { default as editYhAbjddNUrb4ourLszb5sG_eon2S89VYCMV0BKp52jkMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/applicants/[id]/edit.vue?macro=true";
import { default as showPRs5BSDQAwuT3rTn72Pc_45OLbPtOvvl97jM4YqsbSp2QMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/applicants/[id]/show.vue?macro=true";
import { default as createhjMGgEcOnNzdBZAkcLLNwTySVWh4nTHWJonlEHTnDC0Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/service-areas/create.vue?macro=true";
import { default as calendar9tcWF3GVryNHQPAQInW7Ud6ZDxINhIVeYHTTGaNvD3YMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/appointments/calendar.vue?macro=true";
import { default as indexbHt4n_ez9Gao_iHWFK4KOZPobgPiZXmTPc2sOTyrYygMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/funding-sources/index.vue?macro=true";
import { default as showMSFYf9UKIKPKul0b__459RO9SgSS5XsOW89_1xOHiHKTIMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/[id]/show.vue?macro=true";
import { default as territory4CyXXzG7cGcraOXIUoq0_wpZbsJFQKFdLNNq32AgeyMMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/dynamic-form/territory.vue?macro=true";
import { default as createrLWuWsG0QfW_458J0OtoN2s5kimC9GfpyX73BMzZxepw0Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/funding-sources/create.vue?macro=true";
import { default as printUEttFTZsKI25zW3FmsdyfI9QknNfWJMgVEcaQ_45yCagUMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/[id]/print.vue?macro=true";
import { default as indexel_nooE_RpntYn4paSQo8O_45Nx7qKx9cmLg7khJc3R70Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-forms/index.vue?macro=true";
import { default as requiredVTi7Ai7Hcg_45Amyyj6Y_FHDqJevjjE_45bYHCgv_3R8NIYMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/documents/required.vue?macro=true";
import { default as bulk_45update09h0u2btz3VcYHwu_R_0m0n55t9MEeJO_DaczALmTqcMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/bulk-update.vue?macro=true";
import { default as createg89rj_45O5yYrRRVioJBOcQaD9sfcuLz9UuQCCqLjesJ0Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-forms/create.vue?macro=true";
import { default as availabilityEX5jMhFydxsyP1ZXR3DgZ7GaCjwPYRQcIhYdGVTqaMEMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/appointments/availability.vue?macro=true";
import { default as household_45membersclJDfre2N5vtqTW_FbGepDMlXblF6Fj5iDja0DxyAaIMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/reports/household-members.vue?macro=true";
import { default as financial_45assistance7jL_3mdJ3U5SeRlbrO3GlB9aXLZPXE0BNIx2zQsTIyIMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/financial-assistance.vue?macro=true";
import { default as index0gTi643aJ_tnHByYFX39bmxa5I_45POIxYbDGmOCuMv_gMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/funding-sources/[id]/index.vue?macro=true";
import { default as printH4m9cPZo60S1CHYRvRaXn76IZHeRRh9Ikk3cvVw7mDAMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/funding-sources/[id]/print.vue?macro=true";
import { default as _91id_93RHVfVIqO1EvCLriYF6vtq8wZeZN5Eq1fpLY21mBBzLAMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/reports/distributions/[id].vue?macro=true";
import { default as food_45distributionsZtpItJmzApy07_45IaiChdO4XMRvHgVRk0jvUCA2npBbwMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/reports/food-distributions.vue?macro=true";
import { default as indexZ809Dma5Le_45Q6oK_45QsIPaGn_UI0xYspp1rIHRz8LKFMMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-weblinks/index.vue?macro=true";
import { default as indexbTdMBeMLLolWCtUfpckOWPl4ag5iqZFjX1PNtRqU6zYMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/food-assistance/index.vue?macro=true";
import { default as bulk_45update_45arf6Uo6aM8DQnTfTG3I0LOfYIdevf_45Ttun4azfYSbKA44Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/bulk-update-ar.vue?macro=true";
import { default as mass_45communicationsVujUJi3L3njbsRFbDsILUNNVp2iYVT_45PP9EAo7iEUggMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/reports/mass-communications.vue?macro=true";
import { default as editjL6TMgs868NrIWgvX0oZTQf0sL6mKlzSMj6gI7_g34wMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-forms/[id]/edit.vue?macro=true";
import { default as indexySEiQ0j3lglpsrAwhfq0kqA7wTiKYE7ZiMKfLsO_451GwMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-questions/index.vue?macro=true";
import { default as createoHxSDYLEvfwX2XeYbU97D8MeRi_45nnWsrByqEeLcwOQgMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-weblinks/create.vue?macro=true";
import { default as reportSlUmVVIX4kufDiS5c9Fe3Z8ppgGnjfDgiJBIE2_45gyUIMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/advanced-filters/report.vue?macro=true";
import { default as createqOjqfsbqdInlSH6AZhLa_451KAI8irFqpW0F4soN7I_EsMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-questions/create.vue?macro=true";
import { default as qrt1d2ZvDQE6QfHoE0P2Kv6HqretkB_45WSoqrK1xe3F61kMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-weblinks/[id]/qr.vue?macro=true";
import { default as bulk_45update_45pageGjUHQUXxn7Pq6LVGsogOjc97OG1yap8_45vHsUdDYEbpsMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/bulk-update-page.vue?macro=true";
import { default as indexhmVs3Q2m24SdbfANqKqolmbxQbw7F7a9_45vCt0bSU6DQMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/community-services/index.vue?macro=true";
import { default as disaster_45distributions_V6U_5UPsnclBi3yw8OX6J0Lz4XFdZO4Osh4GgAsiqgMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/reports/disaster-distributions.vue?macro=true";
import { default as detailstcqAdrvTkHOceDOdd1wp1OBJ97z_45ViN7L5hgNFpIX1MMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-forms/[id]/details.vue?macro=true";
import { default as editjtPBjsT7WClq0LSaghc7oMHnPETHAuXfVgpn843RpOMMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-weblinks/[id]/edit.vue?macro=true";
import { default as indexJbHcE_45WTJFyb8YwAaEXXT2gzNxbzK14ZBIEVivtqrBEMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/disaster-assistance/index.vue?macro=true";
import { default as edittuzfW8qbx8X0aljtFNIl7p50HOFoVoxvseKDzN0AAHYMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/[id]/[stepId]/edit.vue?macro=true";
import { default as indexbvDb5d_45fFVozEpGQPM7Mhtci_7g1n9ltYlHiQ8oyBZ4Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/reports/fund-transactions/index.vue?macro=true";
import { default as indexkhJmkIeUDGtjjMvBdiUjDf7fYWlKif6SWeha4lyCfc0Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-notifications/index.vue?macro=true";
import { default as edit5xR3Tg7bcDuBLg3_45v_45mQK88TFAgoAciXIi0h_45IBc_78Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-questions/[id]/edit.vue?macro=true";
import { default as bulk_45update_45historyaSpUgwpDVZuVzw6D84mjlY2T1xHq5M2txKwPvADZseoMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/bulk-update-history.vue?macro=true";
import { default as additional_45assistance_45typesNp3gtAx28TqcBnc_Q0l_ioH8b9BoGch7Gt5_PjiHwe4Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/additional-assistance-types.vue?macro=true";
import { default as createWuEgapNkZQbc_457Ge1_qMyI2Rfl7wpw9teRLSMTagpX4Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-notifications/create.vue?macro=true";
import { default as static_45must_45be_45deletedyYksSPLqxOU4oZNe3UwdJxv1TfjFVT4A8iGOrbMdbaUMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/access-code/static-must-be-deleted.vue?macro=true";
import { default as pdf_45mapper1_459thWq1EH_D2iVhwJLslbjfUOicJP2V1Rcbc971e5sMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-forms/[id]/pdf-mapper.vue?macro=true";
import { default as indexta7y6DvkgWQufTprTOHL_n5WoTTsXuF5RWE4_450kBEb0Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/documents/notification/index.vue?macro=true";
import { default as indexok_YB74nVqlUqiuCq_45s5imBU6q3PLGznMpDzJIWE8y4Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/distribution-types/[id]/index.vue?macro=true";
import { default as manageE0VFU_H__453qfEkc27gqsAXTBoI528_M_45sjLjIUclIDAMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/documents/notification/manage.vue?macro=true";
import { default as editousOKdu_YJ_45tmWXtyQAHjM7VVSfy8tW4QaVo0dKTZ74Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-notifications/[id]/edit.vue?macro=true";
import { default as indexnjuRgJLUhafFzd7oSrs1yJAx4qXhBXPcLnEZm8H2tEgMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/documents/funding-source/index.vue?macro=true";
import { default as manage8BqoHfkKFtrvaOcub1FD7PP8paFC2Mt0ItGkSKzAZYwMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/documents/funding-source/manage.vue?macro=true";
import { default as _91id_939pFZTkKEgFZ4act5dlBFceZhxv3MMBPcnFESJkHF3iIMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/food-assistance/food-pantry/[id].vue?macro=true";
import { default as food_45appointmentsf45aexUjeK3aGqa_45ev7UpwXoDoH3oVQzYObV4BUVmLwMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/food-assistance/food-appointments.vue?macro=true";
import { default as createY37aB7_LQl8oax_45_9Y1IG_7Slss4p9Z0TFyKZxDxcc4Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-forms/[id]/questions/create.vue?macro=true";
import { default as configuration9AsiKkU9OBbVAnjzPfXuaB1vscATSvfrOjUvAuWFjwUMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/assistance-types/[id]/configuration.vue?macro=true";
import { default as appointmentsrGFhh7ZtFff_vcQbWR4E9CifWXximTL7p_45OA_45muxkbUMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/distribution-types/[id]/appointments.vue?macro=true";
import { default as calendar_45appointmentsyZyFZP22unLfFNtrFbR2GM2nU7GJWUyXu_45VlTVgCeTIMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/food-assistance/calendar-appointments.vue?macro=true";
import { default as editHKkYfWmozjxFRlFRxSThnJxI244nLUgD1bOYLt3flRYMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-forms/[id]/questions/[qid]/edit.vue?macro=true";
import { default as household_45membersdT66dFmqEBwcveaYV4dabVP6TeJjdDWibwV4MfPXnz0Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/[id]/[stepId]/household-members.vue?macro=true";
import { default as _91id_93OCH9k4jRl5pzBwG0rAgbUcCif3aClUzZySzlN_342voMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/disaster-assistance/disaster-pantry/[id].vue?macro=true";
import { default as calendar_45appointmentsBPIaVpVRlTk8wZIa0YD93eeS7w8lPWXxMoal_lu_ZEAMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/disaster-assistance/calendar-appointments.vue?macro=true";
import { default as disaster_45appointmentsWvbbCIEW5iFK6BEDXTxz2Pw4UCJEKMMKyao12SW8DhgMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/disaster-assistance/disaster-appointments.vue?macro=true";
import { default as _91pantryId_932q6JXvvoaoCpVvQIpxsvkjrE3kVVQBwKR8lHdW3MDKYMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/distribution-types/[id]/pantry/[pantryId].vue?macro=true";
import { default as availability_45appointmentsXSJL5ycsgpyYUTJ675YBKv_45UYTnEWLbiaGeJCt_45fHpUMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/food-assistance/availability-appointments.vue?macro=true";
import { default as availability_45appointmentsKqbnjBHrNd00vk8qMIh0alin_caBA6xlLdkq088M_45IgMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/disaster-assistance/availability-appointments.vue?macro=true";
import { default as calendar_45appointmentsWCo4zkNbTtM0oCJk1IWBg12Mu54bJlisNL2m3EIUsQ4Meta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/distribution-types/[id]/calendar-appointments.vue?macro=true";
import { default as availability_45appointmentsq4u_45d3Vcn72SQAwCsUMiki8EnjulRGpHl2hZFoX030cMeta } from "/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/distribution-types/[id]/availability-appointments.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/index.vue")
  },
  {
    name: "ar-id",
    path: "/ar-:id()",
    meta: ar_45_91id_93LhlK_45R3cSVaIKML1PQT8_ord9SFw3lUXOc6DQ0SHWa4Meta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/ar-[id].vue")
  },
  {
    name: "app-id",
    path: "/app-:id()",
    meta: app_45_91id_93_I6d4Uo5eQxAQVnFJsIs3M9aIlQHVt7T8nH4Z9jE7KEMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/app-[id].vue")
  },
  {
    name: "faqs",
    path: "/faqs",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/faqs/index.vue")
  },
  {
    name: "make-error",
    path: "/make-error",
    meta: make_45errorz3Ag9kCcfFiL9I3X0bCnDvSdJNALdYqVnDbF6UPYnz0Meta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/make-error.vue")
  },
  {
    name: "funds",
    path: "/funds",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/funds/index.vue")
  },
  {
    name: "pdf-summary",
    path: "/pdf/summary",
    meta: summarygvQc9vE_kfwKV3c6_ncEgyXaqdpqWCSn6y8Xr0W0_KMMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/pdf/summary.vue")
  },
  {
    name: "funds-create",
    path: "/funds/create",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/funds/create.vue")
  },
  {
    name: "generate-error",
    path: "/generate-error",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/generate-error.vue")
  },
  {
    name: "schedule",
    path: "/schedule",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/schedule/index.vue")
  },
  {
    name: "oversight",
    path: "/oversight",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/oversight/index.vue")
  },
  {
    name: "pdf-custom-form",
    path: "/pdf/custom-form",
    meta: custom_45formajpYSJHHuSxDSwibBzgwBkDNacGX3xNGBFPTQtPi3skMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/pdf/custom-form.vue")
  },
  {
    name: "pdf-fpl-summary",
    path: "/pdf/fpl-summary",
    meta: fpl_45summaryaoElr_45wA_EORZF7Z0wnYDDrVwBywRnVI_QJUVyjt3aEMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/pdf/fpl-summary.vue")
  },
  {
    name: "applicants",
    path: "/applicants",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/applicants/index.vue")
  },
  {
    name: "funds-id",
    path: "/funds/:id()",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/funds/[id]/index.vue")
  },
  {
    name: "funds-id-print",
    path: "/funds/:id()/print",
    meta: print_454crxpbWzO56lzbX9GVrZGuHLzxCSv8t8n0DusUGGvQMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/funds/[id]/print.vue")
  },
  {
    name: "maps-with-county",
    path: "/maps/with-county",
    meta: with_45countyqtrp9t4yuNarNG2u_45hdjQ7DJA2RmuYngwM6ImlQ8QNsMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/maps/with-county.vue")
  },
  {
    name: "maps-with-marker",
    path: "/maps/with-marker",
    meta: with_45markerybAggDGYH0uZRZxVFg1hPdN9zenDGhpei9ohr_45SXyJEMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/maps/with-marker.vue")
  },
  {
    name: "access-code",
    path: "/access-code",
    meta: index_JuOd4io5GeeAx_4584bNVd4G_45cbcEBV2B9EaPIH8ZyRsMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/access-code/index.vue")
  },
  {
    name: "appointments-id",
    path: "/appointments/:id()",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/appointments/[id].vue")
  },
  {
    name: "documents-preview",
    path: "/documents/preview",
    meta: preview0CUBkymUGLIXfZVSyLSf1_45cFUdTk6ygNtGi2tTZdOUgMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/documents/preview.vue")
  },
  {
    name: "pdf-audit-summary",
    path: "/pdf/audit-summary",
    meta: audit_45summaryG_36qMk3K7NYDrQVHJ13KzXJNdSGi52944562PlCax0Meta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/pdf/audit-summary.vue")
  },
  {
    name: "applications",
    path: "/applications",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/index.vue")
  },
  {
    name: "appointments",
    path: "/appointments",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/appointments/index.vue")
  },
  {
    name: "service-areas-id",
    path: "/service-areas/:id()",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/service-areas/[id].vue")
  },
  {
    name: "appointments-manage",
    path: "/appointments/manage",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/appointments/manage.vue")
  },
  {
    name: "service-areas",
    path: "/service-areas",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/service-areas/index.vue")
  },
  {
    name: "applicants-id-edit",
    path: "/applicants/:id()/edit",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/applicants/[id]/edit.vue")
  },
  {
    name: "applicants-id-show",
    path: "/applicants/:id()/show",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/applicants/[id]/show.vue")
  },
  {
    name: "service-areas-create",
    path: "/service-areas/create",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/service-areas/create.vue")
  },
  {
    name: "appointments-calendar",
    path: "/appointments/calendar",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/appointments/calendar.vue")
  },
  {
    name: "funding-sources",
    path: "/funding-sources",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/funding-sources/index.vue")
  },
  {
    name: "applications-id-show",
    path: "/applications/:id()/show",
    meta: showMSFYf9UKIKPKul0b__459RO9SgSS5XsOW89_1xOHiHKTIMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/[id]/show.vue")
  },
  {
    name: "dynamic-form-territory",
    path: "/dynamic-form/territory",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/dynamic-form/territory.vue")
  },
  {
    name: "funding-sources-create",
    path: "/funding-sources/create",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/funding-sources/create.vue")
  },
  {
    name: "applications-id-print",
    path: "/applications/:id()/print",
    meta: printUEttFTZsKI25zW3FmsdyfI9QknNfWJMgVEcaQ_45yCagUMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/[id]/print.vue")
  },
  {
    name: "admin-custom-forms",
    path: "/admin/custom-forms",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-forms/index.vue")
  },
  {
    name: "admin-documents-required",
    path: "/admin/documents/required",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/documents/required.vue")
  },
  {
    name: "applications-bulk-update",
    path: "/applications/bulk-update",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/bulk-update.vue")
  },
  {
    name: "admin-custom-forms-create",
    path: "/admin/custom-forms/create",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-forms/create.vue")
  },
  {
    name: "appointments-availability",
    path: "/appointments/availability",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/appointments/availability.vue")
  },
  {
    name: "reports-household-members",
    path: "/reports/household-members",
    meta: household_45membersclJDfre2N5vtqTW_FbGepDMlXblF6Fj5iDja0DxyAaIMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/reports/household-members.vue")
  },
  {
    name: "admin-financial-assistance",
    path: "/admin/financial-assistance",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/financial-assistance.vue")
  },
  {
    name: "funding-sources-id",
    path: "/funding-sources/:id()",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/funding-sources/[id]/index.vue")
  },
  {
    name: "funding-sources-id-print",
    path: "/funding-sources/:id()/print",
    meta: printH4m9cPZo60S1CHYRvRaXn76IZHeRRh9Ikk3cvVw7mDAMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/funding-sources/[id]/print.vue")
  },
  {
    name: "reports-distributions-id",
    path: "/reports/distributions/:id()",
    meta: _91id_93RHVfVIqO1EvCLriYF6vtq8wZeZN5Eq1fpLY21mBBzLAMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/reports/distributions/[id].vue")
  },
  {
    name: "reports-food-distributions",
    path: "/reports/food-distributions",
    meta: food_45distributionsZtpItJmzApy07_45IaiChdO4XMRvHgVRk0jvUCA2npBbwMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/reports/food-distributions.vue")
  },
  {
    name: "admin-custom-weblinks",
    path: "/admin/custom-weblinks",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-weblinks/index.vue")
  },
  {
    name: "admin-food-assistance",
    path: "/admin/food-assistance",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/food-assistance/index.vue")
  },
  {
    name: "applications-bulk-update-ar",
    path: "/applications/bulk-update-ar",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/bulk-update-ar.vue")
  },
  {
    name: "reports-mass-communications",
    path: "/reports/mass-communications",
    meta: mass_45communicationsVujUJi3L3njbsRFbDsILUNNVp2iYVT_45PP9EAo7iEUggMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/reports/mass-communications.vue")
  },
  {
    name: "admin-custom-forms-id-edit",
    path: "/admin/custom-forms/:id()/edit",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-forms/[id]/edit.vue")
  },
  {
    name: "admin-custom-questions",
    path: "/admin/custom-questions",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-questions/index.vue")
  },
  {
    name: "admin-custom-weblinks-create",
    path: "/admin/custom-weblinks/create",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-weblinks/create.vue")
  },
  {
    name: "admin-advanced-filters-report",
    path: "/admin/advanced-filters/report",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/advanced-filters/report.vue")
  },
  {
    name: "admin-custom-questions-create",
    path: "/admin/custom-questions/create",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-questions/create.vue")
  },
  {
    name: "admin-custom-weblinks-id-qr",
    path: "/admin/custom-weblinks/:id()/qr",
    meta: qrt1d2ZvDQE6QfHoE0P2Kv6HqretkB_45WSoqrK1xe3F61kMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-weblinks/[id]/qr.vue")
  },
  {
    name: "applications-bulk-update-page",
    path: "/applications/bulk-update-page",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/bulk-update-page.vue")
  },
  {
    name: "admin-community-services",
    path: "/admin/community-services",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/community-services/index.vue")
  },
  {
    name: "reports-disaster-distributions",
    path: "/reports/disaster-distributions",
    meta: disaster_45distributions_V6U_5UPsnclBi3yw8OX6J0Lz4XFdZO4Osh4GgAsiqgMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/reports/disaster-distributions.vue")
  },
  {
    name: "admin-custom-forms-id-details",
    path: "/admin/custom-forms/:id()/details",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-forms/[id]/details.vue")
  },
  {
    name: "admin-custom-weblinks-id-edit",
    path: "/admin/custom-weblinks/:id()/edit",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-weblinks/[id]/edit.vue")
  },
  {
    name: "admin-disaster-assistance",
    path: "/admin/disaster-assistance",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/disaster-assistance/index.vue")
  },
  {
    name: "applications-id-stepId-edit",
    path: "/applications/:id()/:stepId()/edit",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/[id]/[stepId]/edit.vue")
  },
  {
    name: "reports-fund-transactions",
    path: "/reports/fund-transactions",
    meta: indexbvDb5d_45fFVozEpGQPM7Mhtci_7g1n9ltYlHiQ8oyBZ4Meta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/reports/fund-transactions/index.vue")
  },
  {
    name: "admin-custom-notifications",
    path: "/admin/custom-notifications",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-notifications/index.vue")
  },
  {
    name: "admin-custom-questions-id-edit",
    path: "/admin/custom-questions/:id()/edit",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-questions/[id]/edit.vue")
  },
  {
    name: "applications-bulk-update-history",
    path: "/applications/bulk-update-history",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/bulk-update-history.vue")
  },
  {
    name: "admin-additional-assistance-types",
    path: "/admin/additional-assistance-types",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/additional-assistance-types.vue")
  },
  {
    name: "admin-custom-notifications-create",
    path: "/admin/custom-notifications/create",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-notifications/create.vue")
  },
  {
    name: "access-code-static-must-be-deleted",
    path: "/access-code/static-must-be-deleted",
    meta: static_45must_45be_45deletedyYksSPLqxOU4oZNe3UwdJxv1TfjFVT4A8iGOrbMdbaUMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/access-code/static-must-be-deleted.vue")
  },
  {
    name: "admin-custom-forms-id-pdf-mapper",
    path: "/admin/custom-forms/:id()/pdf-mapper",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-forms/[id]/pdf-mapper.vue")
  },
  {
    name: "admin-documents-notification",
    path: "/admin/documents/notification",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/documents/notification/index.vue")
  },
  {
    name: "admin-distribution-types-id",
    path: "/admin/distribution-types/:id()",
    meta: indexok_YB74nVqlUqiuCq_45s5imBU6q3PLGznMpDzJIWE8y4Meta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/distribution-types/[id]/index.vue")
  },
  {
    name: "admin-documents-notification-manage",
    path: "/admin/documents/notification/manage",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/documents/notification/manage.vue")
  },
  {
    name: "admin-custom-notifications-id-edit",
    path: "/admin/custom-notifications/:id()/edit",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-notifications/[id]/edit.vue")
  },
  {
    name: "admin-documents-funding-source",
    path: "/admin/documents/funding-source",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/documents/funding-source/index.vue")
  },
  {
    name: "admin-documents-funding-source-manage",
    path: "/admin/documents/funding-source/manage",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/documents/funding-source/manage.vue")
  },
  {
    name: "admin-food-assistance-food-pantry-id",
    path: "/admin/food-assistance/food-pantry/:id()",
    meta: _91id_939pFZTkKEgFZ4act5dlBFceZhxv3MMBPcnFESJkHF3iIMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/food-assistance/food-pantry/[id].vue")
  },
  {
    name: "admin-food-assistance-food-appointments",
    path: "/admin/food-assistance/food-appointments",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/food-assistance/food-appointments.vue")
  },
  {
    name: "admin-custom-forms-id-questions-create",
    path: "/admin/custom-forms/:id()/questions/create",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-forms/[id]/questions/create.vue")
  },
  {
    name: "admin-assistance-types-id-configuration",
    path: "/admin/assistance-types/:id()/configuration",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/assistance-types/[id]/configuration.vue")
  },
  {
    name: "admin-distribution-types-id-appointments",
    path: "/admin/distribution-types/:id()/appointments",
    meta: appointmentsrGFhh7ZtFff_vcQbWR4E9CifWXximTL7p_45OA_45muxkbUMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/distribution-types/[id]/appointments.vue")
  },
  {
    name: "admin-food-assistance-calendar-appointments",
    path: "/admin/food-assistance/calendar-appointments",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/food-assistance/calendar-appointments.vue")
  },
  {
    name: "admin-custom-forms-id-questions-qid-edit",
    path: "/admin/custom-forms/:id()/questions/:qid()/edit",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/custom-forms/[id]/questions/[qid]/edit.vue")
  },
  {
    name: "applications-id-stepId-household-members",
    path: "/applications/:id()/:stepId()/household-members",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/applications/[id]/[stepId]/household-members.vue")
  },
  {
    name: "admin-disaster-assistance-disaster-pantry-id",
    path: "/admin/disaster-assistance/disaster-pantry/:id()",
    meta: _91id_93OCH9k4jRl5pzBwG0rAgbUcCif3aClUzZySzlN_342voMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/disaster-assistance/disaster-pantry/[id].vue")
  },
  {
    name: "admin-disaster-assistance-calendar-appointments",
    path: "/admin/disaster-assistance/calendar-appointments",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/disaster-assistance/calendar-appointments.vue")
  },
  {
    name: "admin-disaster-assistance-disaster-appointments",
    path: "/admin/disaster-assistance/disaster-appointments",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/disaster-assistance/disaster-appointments.vue")
  },
  {
    name: "admin-distribution-types-id-pantry-pantryId",
    path: "/admin/distribution-types/:id()/pantry/:pantryId()",
    meta: _91pantryId_932q6JXvvoaoCpVvQIpxsvkjrE3kVVQBwKR8lHdW3MDKYMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/distribution-types/[id]/pantry/[pantryId].vue")
  },
  {
    name: "admin-food-assistance-availability-appointments",
    path: "/admin/food-assistance/availability-appointments",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/food-assistance/availability-appointments.vue")
  },
  {
    name: "admin-disaster-assistance-availability-appointments",
    path: "/admin/disaster-assistance/availability-appointments",
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/disaster-assistance/availability-appointments.vue")
  },
  {
    name: "admin-distribution-types-id-calendar-appointments",
    path: "/admin/distribution-types/:id()/calendar-appointments",
    meta: calendar_45appointmentsWCo4zkNbTtM0oCJk1IWBg12Mu54bJlisNL2m3EIUsQ4Meta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/distribution-types/[id]/calendar-appointments.vue")
  },
  {
    name: "admin-distribution-types-id-availability-appointments",
    path: "/admin/distribution-types/:id()/availability-appointments",
    meta: availability_45appointmentsq4u_45d3Vcn72SQAwCsUMiki8EnjulRGpHl2hZFoX030cMeta || {},
    component: () => import("/home/vsts/work/1/s/packages/admin-dashboard/pages/admin/distribution-types/[id]/availability-appointments.vue")
  }
]